import {Component, OnInit, OnDestroy, ViewContainerRef, ChangeDetectorRef, AfterContentChecked} from '@angular/core';
import {
    Router,
    Event as RouterEvent,
    NavigationStart,
    NavigationEnd,
    NavigationCancel,
    NavigationError,
    ActivatedRoute
} from '@angular/router';

import {Globals} from './globals';
import {ModalService} from '@myServices/modal.service';
import {AuthenticationService} from '@myServices/authentication.service';
import {LocalStorageService} from '@myServices/localstorage.service';
import {EventService} from '@myServices/event.service';
import {OverlayService} from '@myServices/overlay.service';
import {NotificationService} from '@myServices/notification.service';
import {CustomHttpService} from '@Shared/services';
import {Subject} from "rxjs/Subject";
import {takeUntil} from "rxjs/operators";
import {GlobalLoaderService} from "@myServices/global-loader.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterContentChecked, OnDestroy {
    public moveBodyDown: Boolean;
    public isSideBarOpen = false;
    public user: object = null;
    public isUserAuthenticated: boolean = false;
    public overlayShown = true;
    public isMobile: boolean = false;
    private destroy$ = new Subject();
    public isLoading = false;
    public isAuthControlComplete = false;
    constructor(
        private globals: Globals,
        private modalService: ModalService,
        private authenticationService: AuthenticationService,
        private localStorageService: LocalStorageService,
        private eventService: EventService,
        private overlayService: OverlayService,
        private notificationService: NotificationService,
        private vcr: ViewContainerRef,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private http: CustomHttpService,
        public loader: GlobalLoaderService,
        private cdr: ChangeDetectorRef) {
        router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event);
        });
        this.globals.checkWidth();
    }

    // Shows and hides the loading spinner during RouterEvent changes
    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.overlayService.onOverlayChange(true);
        }
        if (event instanceof NavigationEnd) {
            const lastUrl = localStorage.getItem('lastUrl') || null;
            this.overlayService.onOverlayChange(false);
            this.removeModal();
            this.globals.onSideBarChange(false);
            localStorage.setItem('lastUrl', event.url);
        }
        if (event instanceof NavigationCancel) {
            this.overlayService.onOverlayChange(false);
        }
        if (event instanceof NavigationError) {
            this.overlayService.onOverlayChange(false);
        }

    }

    ngOnInit() {
        this.notificationService.setContainerRef(this.vcr);
        this.authenticationService.initializeSite().then(() => {
            this.overlayService.onOverlayChange(false);
            this.setEvents();
            setTimeout(() => {
                this.isAuthControlComplete = true;
            }, 500);
            // this.showOverlay = false;
        }).catch(error => {
            // this.showOverlay = false;
            // add a notification here to tell the user that something went wrong
            setTimeout(() => {
                this.isAuthControlComplete = true;
            }, 500);
        });
        // this.globals.checkWidth();
        this.globals.triggerResizeEvent();
        this.globals.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
            this.isMobile = isMobile;

        });
        this.globals.getSideBarStatus().pipe(takeUntil(this.destroy$)).subscribe(isSideBarOpen => {
            this.isSideBarOpen = isSideBarOpen;
            this.moveBodyDown = !isSideBarOpen;
        });
        this.overlayService.getOverlayStatus().subscribe(status => {
            if (status) {
                return this.overlayShown = true;
            }
            return this.overlayShown = false;
        });

        this.loader.getLoading().subscribe((res: boolean) => {
            this.isLoading = res;
        })

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['qrScan']) {
                this.authenticationService.qrCodeValue = params['qrScan'];
            } else if (!!this.authenticationService.qrCodeValue) {
                this.authenticationService.qrCodeValue = null;
            }
        });

    }

    ngAfterContentChecked(): void {
        this.cdr.detectChanges();
    }

    private setEvents(): void {
        this.eventService.getUserInfo()
            .subscribe(data => {
                this.setUserData(data.user);
            });
        this.eventService.getAuthenticationStatus()
            .subscribe(data => {
                this.setUserStatus(data.status);
            });
    }

    private setUserStatus(status) {
        this.isUserAuthenticated = status;
        this.eventService.isUserLoggedIn = status;
        this.authenticationService.isUserLoggedIn = status;
    }

    private setUserData(user): void {
        this.user = user;
        this.localStorageService.setItem('USER_INFO', user);
    }

    removeModal() {
        this.modalService.destroy();
        document.body.classList.remove('game-modal-header');
    }

    ngOnDestroy(): any {
        this.destroy$.next();
        this.authenticationService.alive = false;
        this.isUserAuthenticated = false;
        this.authenticationService.isUserLoggedIn = false;
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/app.component.ts